import { AfterViewInit, Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';
import { StripeService } from 'ngx-stripe';
import {
  StripeCardCvcElement,
  StripeCardExpiryElement,
  StripeElements,
  StripeElementsOptions,
  StripeCardNumberElement,
} from '@stripe/stripe-js';
import { switchMap, take } from 'rxjs/operators';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { createAlertConfig } from '../shared/factoryconfigAlert';
import { forkJoin, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'pagamento-rinnovo',
  templateUrl: './pagamento-rinnovo.component.html',
  styleUrls: ['./pagamento-rinnovo.component.css']
})
/** pagamentoRinnovo component*/
export class PagamentoRinnovoComponent implements OnInit, AfterViewInit {

  today = new Date();

  amiciFedeli: any[] = [];
  soci: any[] = [];

  nomeCognomeSocio: string;
  pagamento: any = {};
  pagamentoLoading: boolean = false;

  elements: StripeElements;
  card: StripeCardNumberElement;
  cvc: StripeCardCvcElement;
  expire: StripeCardExpiryElement;

  cardInvalid: boolean = true;
  cardNumberInvalid: boolean = false;
  expireInvalid: boolean = false;
  cvcInvalid: boolean = false;
  errorPayment: string;

  errorCardNumber: string = undefined;
  errorCvc: string = undefined;
  errorExpire: string = undefined;

  enableContributo: boolean = false;

  styleOptions = {
    style: {
      base: {
        iconColor: "#363636",
        color: "#363636",
        fontWeight: 400,
        fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",

      },
      invalid: {
        iconColor: "#E02836",
        color: "#E02836"
      }
    }
  };
  cardBrandToPfClass = {
    'visa': 'fab fa-cc-visa',
    'mastercard': 'fab fa-cc-mastercard',
    'amex': 'fab fa-cc-amex',
    'discover': 'fab fa-cc-discover',
    'diners': 'fab fa-cc-diners-club',
    'jcb': 'fab fa-cc-jcb',
    'unknown': 'fas fa-credit-card',
  }
  cardClassIcon = 'fas fa-credit-card';
  setBrandIcon(brand) {
    this.cardClassIcon = 'fas fa-credit-card';
    if (brand in this.cardBrandToPfClass) {
      this.cardClassIcon = this.cardBrandToPfClass[brand];
    }
  }
  elementsOptions: StripeElementsOptions = {
    locale: 'it'
  };

  constructor(@Inject(LOCALE_ID) public locale: string, private router: Router, private authService: AuthenticationService,
    private stripeService: StripeService, private alertService: NwbAlertService,
    private dataService: DataService, private viewportScroller: ViewportScroller) {

  }

  ngOnInit(): void {
    this.elementsOptions.locale = this.locale.includes("it") ? "it" : "en";
    forkJoin([this.dataService.getInfoPagamento(), this.dataService.getTempPagamento(), this.dataService.getData().pipe(take(1))])
      .subscribe(([info, tempPayment, data]) => {
        let dataPagamento = info;
        this.nomeCognomeSocio = data.nomeCompleto;
        this.pagamento = tempPayment;
        this.soci = dataPagamento.soci;
        this.amiciFedeli = dataPagamento.amiciFedeli;

        if (this.pagamento) {
          this.pagamento.importo = 0;
          let indexRiga = 0;
          while (indexRiga < this.pagamento.righePagamento.length) {
            if (this.pagamento.righePagamento[indexRiga].tipoBeneficiario == 1) {
              let index = this.soci.findIndex(s => s.id == this.pagamento.righePagamento[indexRiga].idBeneficiario);
              if (index > -1 && this.soci[index].valido) {
                this.pagamento.importo += this.soci[index].importo;
                this.soci[index].checked = true;
                this.pagamento.righePagamento[indexRiga].importo = this.soci[index].importo;

                ++indexRiga;
              } else {
                this.pagamento.righePagamento.splice(indexRiga, 1);
              }
            } else {
              let index = this.amiciFedeli.findIndex(a => a.id == this.pagamento.righePagamento[indexRiga].idBeneficiario);
              if (index > -1) {
                this.pagamento.importo += this.amiciFedeli[index].importo;

                this.amiciFedeli[index].checked = true;
                this.pagamento.righePagamento[indexRiga].importo = this.amiciFedeli[index].importo;

                ++indexRiga;
              } else {
                this.pagamento.righePagamento.splice(indexRiga, 1);
              }
            }
          }

        } else {
          this.pagamento = {
            righePagamento: []
          };
          //il socio collegato all'account e' sempre il primo
          if (this.soci[0].valido) {
            this.soci[0].checked = true;
            this.pagamento.importo = this.soci[0].importo;
            this.pagamento.righePagamento.push({
              idBeneficiario: this.soci[0].id,
              tipoBeneficiario: 1,
              importo: this.soci[0].importo
            });
          } else {
            this.pagamento.importo = 0;
          }
        }
      });
  }


  ngAfterViewInit(): void {


    this.stripeService.elements(this.elementsOptions).subscribe(elements => {
      this.elements = elements;

      this.viewportScroller.scrollToAnchor('idRichiestaRinnovo');

      // Only mount the element the first time
      if (!this.card) {
        this.card = this.elements.create('cardNumber', this.styleOptions);
        this.card.mount('#card-number-element');

        this.card.on("change", (event) => {
          if (event.brand) {
            this.setBrandIcon(event.brand);
          }
          if (event.error) {
            this.cardNumberInvalid = true;
            this.errorCardNumber = event.error.message;
          } else {
            this.cardNumberInvalid = false;
            this.errorCardNumber = undefined;
          }
          this.cardInvalid = this.cvcInvalid || this.expireInvalid || this.cardNumberInvalid;
          this.errorPayment = [this.errorCardNumber, this.errorCvc, this.errorExpire].filter(s => s).join(", ");
        });
      }

      if (!this.expire) {
        this.expire = this.elements.create('cardExpiry', this.styleOptions);
        this.expire.mount('#card-expiry-element');

        this.expire.on("change", (event) => {
          if (event.error) {
            this.expireInvalid = true;
            this.errorExpire = event.error.message;
          } else {
            this.expireInvalid = false;
            this.errorExpire = undefined;
          }
          this.cardInvalid = this.cvcInvalid || this.expireInvalid || this.cardNumberInvalid;
          this.errorPayment = [this.errorCardNumber, this.errorCvc, this.errorExpire].filter(s => s).join(", ");
        });
      }

      if (!this.cvc) {
        this.cvc = this.elements.create('cardCvc', this.styleOptions);
        this.cvc.mount('#card-cvc-element');

        this.cvc.on("change", (event) => {
          if (event.error) {
            this.cvcInvalid = true;
            this.errorCvc = event.error.message;
          } else {
            this.cvcInvalid = false;
            this.errorCvc = undefined;
          }
          this.cardInvalid = this.cvcInvalid || this.expireInvalid || this.cardNumberInvalid;
          this.errorPayment = [this.errorCardNumber, this.errorCvc, this.errorExpire].filter(s => s).join(", ");
        });
      }
    });
  }

  setCheckBeneficiario(event: any, entita: any, tipo: number) {

    let index = this.pagamento.righePagamento.findIndex(r => r.idBeneficiario == entita.id && r.tipoBeneficiario == tipo);

    if (event.target.checked) {//aggiungo al pagamento
      if (index == -1) {
        this.pagamento.righePagamento.push({
          idBeneficiario: entita.id,
          tipoBeneficiario: tipo,
          importo: entita.importo
        });
        this.pagamento.importo += entita.importo;
      }
    } else if (index > -1) {
      this.pagamento.importo -= this.pagamento.righePagamento[index].importo;
      this.pagamento.righePagamento.splice(index, 1);
    }
  }

  savePagamento() {
    this.pagamentoLoading = true;
    let profile = this.authService.getUserProfile();
    let name = `${profile.idSocio} ${this.nomeCognomeSocio} ${profile.email}`;
    this.stripeService.createPaymentMethod({
      type: 'card', card: this.card,
      billing_details: { name: name }
    })
      .pipe(switchMap((result) => {
        if (result.error) {
          if (!this.cardInvalid) {
            this.showErrorMessageCreditCard(result.error);
          } else {
            this.pagamentoLoading = false;
          } //gia' messo sopra tramite i change

          return of(undefined)
        } else {
          this.pagamento.paymentStripeId = result.paymentMethod.id;
          return this.dataService.addNuovoPagamento(this.pagamento);
        }
        //data

      })).subscribe((result) => {
        if (!result) { //errore gia' gestito sopra 

          return;
        }
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          this.showErrorMessageCreditCard(result.error);
        } else {
          // The payment has been processed!
          this.manageResponseStripeFromServer(result);
        }
      }, error => {  
        this.showErrorMessageCreditCard(error.error);
      });
  }

  private manageResponseStripeFromServer(result: any) {

    if (result.requiresAction) {
      this.stripeService.handleCardAction(result.paymentIntentClientSecret)
        .pipe(switchMap((result) => {
          if (result.error) {
            this.showErrorMessageCreditCard(result.error);
            return of(undefined)
          } else {
            return this.dataService.confirmPayment(result.paymentIntent.id, result.paymentIntent.payment_method)
          }
        })).subscribe((result: any) => {

          if (result) {
            this.manageResponseStripeFromServer(result); //chiamata ricorsiva. possono essere richieste verifiche in successione o altro
          }
          //se non ha valore gia' gestito

        }, (err) => {
          this.showErrorMessageCreditCard(err.error);
        });;
    } else if (result.isSuccess) {

      //needto check!
      if (this.locale == 'it') {
        this.alertService.open(createAlertConfig("Pagamento avvenuto con successo! Sarai reindirizzato alla pagina account", true)).afterClosed().subscribe();
      } else {
        this.alertService.open(createAlertConfig("Payment succeded! You will be redirect to the account page", true)).afterClosed().subscribe();
      }
      //pagamento effettuato, forzare refresh!
      this.dataService.getData(true).subscribe(() => {
        setTimeout(() => {
          this.router.navigate(['/area-utente']);
        }, 1000);
      });

    } else {
      this.showErrorMessageCreditCard(result.error);
    }
  }



  private showErrorMessageCreditCard(error: any) {

    if (!error?.code) {
      if (this.locale == 'it') {
        this.errorPayment = "Errore durante il pagamento";
      } else {
        this.errorPayment = "Error while process the payment";
      }
    } else {
      switch (error.code) {
        case "acss_debit_session_incomplete":
        case "rate_limit_error":

          if (this.locale == 'it') {
            this.errorPayment = "Errore nel sistema di pagamento, riprovare più tardi";
          } else {
            this.errorPayment = "Error in the payment system, try again later";
          }
          break;
        case "card_decline_rate_limit_exceeded":
          if (this.locale == 'it') {
            this.errorPayment = "Carta rifiutata. Riprovare tra un giorno, se persiste contattare la propria banca";
          } else {
            this.errorPayment = "Card has been declined. Try the next day, if the error is still present contact your bank";
          }
          break;
        case "api_connection_error":
        case "api_error":
          if (this.locale == 'it') {
            this.errorPayment = "Errore durante il pagamento, riprovare più tardi";
          } else {
            this.errorPayment = "Error while prcocess the payment. Try again later";
          }
          break;
        case "invalid_expiry_month":
        case "invalid_expiry_year":
        case "expired_card":
          if (this.locale == 'it') {
            this.errorPayment = "Carta scaduta. Controllare il dato o usare un'altra carta";
          } else {
            this.errorPayment = "The card has expired. Check the expiration date or use a different card";
          }
          break;
        case "invalid_cvc":
        case "incorrect_cvc":
          if (this.locale == 'it') {
            this.errorPayment = "Cvc non valido. Controllare il dato o usare un'altra carta";
          } else {
            this.errorPayment = "Cvc not valid. Check the expiration date or use a different card";
          }
          break;
        case "invalid_number":
        case "incorrect_number":
          if (this.locale == 'it') {
            this.errorPayment = "Numero carta non corretto. Controllare il dato o usare un'altra carta";
          } else {
            this.errorPayment = "The card number is incorrect. Check the expiration date or use a different card";
          }
          break;
        case "invalid_characters":
          if (this.locale == 'it') {
            this.errorPayment = "Caratteri non validi presenti. Togliere i caratteri non validi";
          } else {
            this.errorPayment = "Characters not valid in the form. Remove them";
          }
          break;
        case "invalid_amount":
        case "invalid_charge_amount":
          if (this.locale == 'it') {
            this.errorPayment = "Importo non valido per la carta";
          } else {
            this.errorPayment = "The specified amount is invalid";
          }
          break;
        //questo blocco di codice contiene anche tutte le evenienze dove la carta e' rubata. Non vanno fornite troppe informazioni
        case "transaction_not_allowed":
        case "stolen_card":
        case "security_violation":
        case "service_not_allowed":
        case "revocation_of_authorization":
        case "revocation_of_all_authorizations":
        case "restricted_card":
        case "pickup_card":
        case "new_account_information_available":
        case "no_action_taken":
        case "not_permitted":
        case "lost_card":
        case "merchant_blacklist":
        case "generic_decline":
        case "fraudulent":
        case "do_not_try_again":
        case "do_not_honor":
        case "card_velocity_exceeded":
        case "card_not_supported":
        case "call_issuer":
          if (this.locale == 'it') {
            this.errorPayment = "Carta rifiutata. Contattare la propria banca per maggiori informazioni";
          } else {
            this.errorPayment = "Card has been declined. contact your bank for more information";
          }
          break;
        case "approve_with_id":
        case "authentication_required":
        case "payment_intent_authentication_failure":
          if (this.locale == 'it') {
            this.errorPayment = "Riprovare l'autenticazione. Se l'errore persiste contattare la propria banca";
          } else {
            this.errorPayment = "Try again and authenticate the card. If this error message show again, contact your bank for more information";
          }
          break;
        case "currency_not_supported":
          if (this.locale == 'it') {
            this.errorPayment = "Questa carta non supporta pagamenti in euro. Impossibile continuare";
          } else {
            this.errorPayment = "This card does not support the euro currency. Unable to continue.";
          }
          break;
        case "insufficient_funds":
          if (this.locale == 'it') {
            this.errorPayment = "Fondi non sufficienti per questa carta";
          } else {
            this.errorPayment = "Insufficient funds. Try another card";
          }
          break;

        case "duplicate_transaction":
          if (this.locale == 'it') {
            this.errorPayment = "Verificare che la transazione non sia già stata effettuata. Se non è così riprovare";
          } else {
            this.errorPayment = "Check to see if a recent payment already exists. If everything is okay try again";
          }
          break;
        case "issuer_not_available":
          if (this.locale == 'it') {
            this.errorPayment = "Circuito non disponibile. Riprovare più tardi";
          } else {
            this.errorPayment = "Card circuit not available. Try again later";
          }
          break;

        case "try_again_later":
        case "reenter_transaction":
        case "processing_error":
          if (this.locale == 'it') {
            this.errorPayment = "Errore nel processare il pagamento. Riprovare più tardi. Se l'errore persiste contattare la propria banca";
          } else {
            this.errorPayment = "Error while proccess the payment. Try again later. If the error persist contact your bank";
          }
          break;

        case "online_or_offline_pin_required":
        case "invalid_pin":
          if (this.locale == 'it') {
            this.errorPayment = "Verificare il pin immesso.";
          } else {
            this.errorPayment = "Check the provided pin";
          }
          break;
        case "authentication_error":
        case "invalid_request_error":
        case "validation_error":
        default:
          // Unknown Error Type
          if (this.locale == 'it') {
            this.errorPayment = "Errore durante il pagamento. Nessuna informazione aggiuntiva disponibile";
          } else {
            this.errorPayment = "Error while proccess the payment. No more information available";
          }
          break;
      }
    }

    this.pagamentoLoading = false;
  }
}
